import { useCallback, useEffect } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import Clear from '@material-ui/icons/Clear'
import { ROUTES } from '../../../../constants'
import { STORE_EVENT_TYPES } from 'lib/enums/shared.enums'
import { selectActiveWorkspace } from 'lib/helpers/selectors'
import useStoreEvent from 'hooks/Shared/useStoreEvent'
import { useAppSelector } from 'store/hooks'
import { resetForm } from 'actions/forms'
import AddCreditNoteContainer from 'containers/Invoices/CreditNotes/AddCreditNoteContainer/AddCreditNoteContainer'
import Button from 'components/Shared/Button/Button'
import './styles.scss'

const AddCreditNoteScreen = () => {
  const { invoice } = useParams()

  const invoiceId = Number(invoice)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const workspaceId = useAppSelector(selectActiveWorkspace)

  const cleanup = useCallback(() => {
    navigate(ROUTES.INVOICES, { replace: true })
    dispatch(resetForm('createCreditNote'))
  }, [dispatch, navigate])

  useStoreEvent(STORE_EVENT_TYPES.ACTIVE_WORKSPACE_CHANGE, cleanup)

  useEffect(
    () => () => {
      window.scrollTo(0, 0)
      cleanup()
    },
    [cleanup]
  )

  if (!invoiceId) {
    return <Navigate to={ROUTES.INVOICES} replace />
  }

  if (!workspaceId) {
    return <Navigate to={ROUTES.HOME} replace />
  }

  return (
    <Grid container spacing={0} className="screen-add-credit-note">
      <Grid item xs={12}>
        <div className="title-container">
          <h1>Nueva nota de crédito</h1>
          <Button
            id="cancelBtn"
            variant="hover"
            color="secondary"
            startIcon={<Clear />}
            onClick={cleanup}>
            Cancelar
          </Button>
        </div>
      </Grid>
      <Grid item xs={12}>
        <AddCreditNoteContainer
          workspaceId={workspaceId}
          invoiceId={invoiceId}
          cleanup={cleanup}
        />
      </Grid>
    </Grid>
  )
}

export default AddCreditNoteScreen
